import React, { useContext, useState, useEffect } from 'react';
import Router from 'next/router';
import { LoginDataContext } from '@contexts/LoginDataContext';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { HeaderContext } from '@contexts/HeaderContext';
import { confirmRulesVersion } from '@utils/LoginProcess/requests';
import { LoginDataAction } from '@reducers/LoginDataReducer';
import { useTranslation } from 'next-i18next';
import ServerPath from '../../configs/serverPath';

const MemberRules = () => {
    const [loginData, loginDataDispatch] = useContext(LoginDataContext);
    const { composePath, clientApiUrl, rsaPublicKey: rsaInfo } = useSiteInfo();
    const [headerState] = useContext(HeaderContext);
    const { language } = headerState;
    const [memberRulesLang, setMemberRulesLang] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        setMemberRulesLang(language);
        if (language === 'zhcn') {
            setMemberRulesLang('cs');
        }
        if (language === 'mm') {
            setMemberRulesLang('en');
        }
    }, [language]);

    const handleAgreeMemberRules = async () => {
        try {
            await confirmRulesVersion(clientApiUrl, loginData, rsaInfo);
            if (loginData.redirectUrl) {
                Router.push(loginData.redirectUrl);
            }
        } catch (error) {
            loginDataDispatch({
                type: LoginDataAction.TOGGLE_SHOWING_MEMBER_RULES,
                payload: {
                    isShowMemberRules: false,
                },
            });
            console.error(error);
        }
    };

    const handleDisagreeMemberRules = () => {
        loginDataDispatch({
            type: LoginDataAction.TOGGLE_SHOWING_MEMBER_RULES,
            payload: {
                isShowMemberRules: false,
            },
        });
    };

    return (
        <div className="main">
            <div className="main__container">
                { memberRulesLang && (
                    <iframe
                        title="MemberRules"
                        src={composePath({
                            pathType: ServerPath.helpUiHtml,
                            language: memberRulesLang,
                            pathName: '_NewmemberConfirm.html',
                        })}
                    />
                )}
                <div className="btn-group">
                    <a
                        className="btn btn--agree"
                        onClick={handleAgreeMemberRules}
                    >
                        <span className="text">{t('lbl_Agree')}</span>

                    </a>
                    <a
                        className="btn btn--disagree"
                        onClick={handleDisagreeMemberRules}
                    >
                        <span className="text">{t('lbl_Disagree')}</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MemberRules;
